import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/products/cabin/webp/eurocab-1-card.webp")